interface Props {
  value?: number;
  variant?: 'determinate' | 'indeterminate';
  backgroundColor?: string;
  containerBackgroundColor?: string;
}

export const LinearLoader = ({
  variant = 'indeterminate',
  value = 0,
  backgroundColor = 'bg-primary-400',
  containerBackgroundColor = 'bg-primary-400/10',
}: Props) => {
  const clampedValue = Math.min(Math.max(value, 0), 100);

  return (
    <div
      className={`w-full ${containerBackgroundColor} overflow-hidden relative h-1 rounded`}
      role="progressbar"
      aria-valuenow={variant === 'determinate' ? clampedValue : undefined}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      {variant === 'determinate' ? (
        <div
          className={`h-full ${backgroundColor} transition-all duration-300 ease-out rounded`}
          style={{ width: `${clampedValue}%` }}
        />
      ) : (
        <>
          <div
            className={`absolute h-full ${backgroundColor} animate-indeterminate-1`}
          />
          <div
            className={`absolute h-full ${backgroundColor} animate-indeterminate-2 [animation-delay:1.15s]`}
          />
        </>
      )}
    </div>
  );
};
